// extracted by mini-css-extract-plugin
export var columnItem = "_g2-3";
export var columnItemDraggable = "_g2-5";
export var dragHandle = "_g2-0";
export var dragHandleHovered = "_g2-1";
export var dropdown = "_g2-6";
export var dropdownContent = "_g2-8";
export var dropdownInner = "_g2-7";
export var filterDropdownHeader = "_g2-9";
export var icon = "_g2-2";
export var moveToTopButton = "_g2-4";
export var sectionDivider = "_g2-a";